import { useEffect } from 'react'
import PubSub from 'pubsub-js'
import { PUBSUB_TOPICS } from 'variables/pubsub'
import { type DocumentNode } from 'graphql'

export interface GraphQLError {
  message: string
  operationName: string
  payload: Record<string, any> | null
  query: DocumentNode | null
  extensions: { [key: string]: any }
}

type GraphQLErrorSubscribeCallback = (err: GraphQLError) => void

export const useGraphQLErrorSubscribe = (callback: GraphQLErrorSubscribeCallback) => {
  useEffect(() => {
    PubSub.subscribe(PUBSUB_TOPICS.GRAPH_HAVE_ERROR, (_, errorMessages: string) => {
      try {
        callback(JSON.parse(errorMessages))
      } catch {
        callback({
          message: errorMessages,
          operationName: 'unknown',
          payload: null,
          query: null,
          extensions: { errorCode: 'unknown' },
        })
      }
    })

    return () => {
      PubSub.unsubscribe(PUBSUB_TOPICS.GRAPH_HAVE_ERROR)
    }
  }, [callback])
}

export const graphQLErrorPubSubPublish = (graphQLError: GraphQLError) =>
  PubSub.publish(PUBSUB_TOPICS.GRAPH_HAVE_ERROR, JSON.stringify(graphQLError))
